import { PageMeta } from 'constants/pages';
import { ArticleSections } from 'types/articles';
import {
  classicalSimulationTestingData,
  classicalSimulationTestingMeta,
} from './classical-simulation-testing-doesnt-scale';

interface TechnicalBriefParameters {
  pageMeta: PageMeta;
  articleData: ArticleSections[];
}

export const TECHNICAL_BRIEFS: TechnicalBriefParameters[] = [
  {
    pageMeta: classicalSimulationTestingMeta,
    articleData: classicalSimulationTestingData,
  },
];
